import { CILabel, Textarea } from 'ccs-ui-components';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NamespaceItemHandler from '../param-list-handler/NamespaceItemHandler';
import classes from './SoapParamFields.module.scss';
import NamespaceInputHandler from '../param-handler/NamespaceInputHandler';
import { INameSpaceParam, IServiceDetailsValidationModel } from '../../../../../models';

interface ISoapParamProps {
  soapNamespaceListHandler: (data: INameSpaceParam[]) => void;
  soapNamespaceList: INameSpaceParam[] | undefined;
  formData: IServiceDetailsValidationModel;
  validateXml: () => void;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isViewMode: boolean
}
const SoapParamFields = ({
  soapNamespaceListHandler,
  soapNamespaceList,
  formData,
  validateXml,
  handleInputChange,
  isViewMode
}: ISoapParamProps) => {
  const { t: translate } = useTranslation();
  return (
    <Row>
      <Form.Group controlId="headerXml" className="pb-3">
        <Textarea
          labelText={String(translate('service_details_form_component.lbl_headerJson'))}
          label=""
          name="headerXml"
          value={formData.headerXml.value}
          placeholder={String(
            translate('service_details_form_component.plchd_headerJson')
          )}
          onBlur={validateXml}
          onChange={handleInputChange}
          data-testid="headerXml"
          maxLength={Number.MAX_SAFE_INTEGER}
          error={!formData.headerXml.isValid}
          errorTxt={formData.headerXml.error}
        />
      </Form.Group>
      <Form.Group className="pb-3">
        <CILabel id="nameSpace" isMandatory labelText={translate('service_details_form_component.lbl_namespace')} />
        {!isViewMode ? (
          <NamespaceInputHandler
            listOfItems={soapNamespaceListHandler}
            paramName="Namespace"
            list={soapNamespaceList}
          />
        ) : (
          <Row className={classes['param-container']}>
            <Row className={classes['param-header']}>
              <Col sm={5}>{translate('service_operation_form.param_key')}</Col>
              <Col sm={6} className={classes['value-header']}>
                {translate('service_operation_form.param_value')}
              </Col>
            </Row>
            {(!soapNamespaceList || soapNamespaceList?.length < 1) && (
              <div className={classes['no-data']}>
                {translate('service_details_form_component.plchd_no_records', {
                  replace: { param: 'Namespaces' }
                })}
              </div>
            )}
            {soapNamespaceList?.map((item, index) => (
              <NamespaceItemHandler
                key={item.prefix}
                index={index}
                itemKey={item.prefix}
                itemValue={item.namespace}
                isEdit={item.isEdit}
                isView
              />
            ))}
          </Row>
        )}
      </Form.Group>
    </Row>
  );
};

export default SoapParamFields;
